export default __webpack_public_path__ + "static/media/Mind's Ire.928e4952.jpg";